import POSSelectorButton from '../../../Buttons/POSSelectorButton';

interface Props {
  selectedSubCategoryName?: string;

  disabled?: boolean;

  onClick: () => void;
}

const POSSubCategoryFilterCard = ({
  selectedSubCategoryName,
  disabled,
  onClick,
}: Props) => {
  return (
    <POSSelectorButton
      label="Subcategoría"
      value={selectedSubCategoryName || 'Todas las subcategorías'}
      selected={!!selectedSubCategoryName}
      disabled={disabled}
      onClick={onClick}
    />
  );
};

export default POSSubCategoryFilterCard;
